var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261157344"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2125",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    d: "M6.0312 6L10.9813 12.6187L6 18H7.12119L11.4824 13.2885L15.0061 18H18.8213L13.5925 11.0091L18.2291 6H17.108L13.0916 10.3391L9.84638 6H6.0312ZM7.67995 6.82578H9.43263L17.1723 17.1742H15.4196L7.67995 6.82578Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitterIcon.642feb2637f1c64c13b59cd9420c79cb.svg";
export { ForwardRef as ReactComponent };